import { isPatientPaymentPaid } from 'domains/claims/status';
import { SuperbillSummary } from 'domains/superbillPDF/data/localStorage';

export const calculatePayments = ({ claim, note, payment }: Pick<SuperbillSummary, 'claim' | 'note' | 'payment'>) => {
  let charge: number;
  let paidByPatient: number;

  if (claim) {
    // Insurance payments are always inside the claim
    charge = (claim.claims[0]?.service_lines ?? []).reduce(
      (total, serviceLine) => total + (serviceLine.charge_amount_cents ?? 0),
      0,
    );

    paidByPatient = (claim.patient_payments ?? [])
      .filter(patientPayment => isPatientPaymentPaid(patientPayment.status))
      .reduce((total, patientPayment) => total + (patientPayment.amount_cents ?? 0), 0);
  } else if (note.eventType === 'evaluation-note') {
    // Self-pay evaluation note has no invoice
    charge = note.charge?.amount ?? 0;
    paidByPatient = note.charge?.status === 'succeeded' ? charge : 0;
  } else {
    // Self-pay session note has payment (from Stripe)
    charge = payment?.total ?? 0;
    paidByPatient = payment?.status === 'paid' ? charge : 0;
  }

  return { charge, paidByPatient };
};
